module.exports = __webpack_public_path__ + "img/card-services-month-certification-hover.3c50bfff.svg";